const MOBILE_VIEWPORT = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
const DEFAULT_VIEWPORT = 'width=804, user-scalable=no';

let originalViewport = '';
let viewportMeta = null;

function getViewportMeta() {
  if (!viewportMeta) {
    viewportMeta = document.querySelector('meta[name="viewport"]');
  }
  return viewportMeta;
}

function useMobileViewport() {
  const meta = getViewportMeta();
  if (meta) {
    originalViewport = meta.getAttribute('content') || DEFAULT_VIEWPORT;
    meta.setAttribute('content', MOBILE_VIEWPORT);
  }
}

function restoreViewport() {
  const meta = getViewportMeta();
  if (meta && originalViewport) {
    meta.setAttribute('content', originalViewport);
  }
}

export default {
  mounted() {
    useMobileViewport();
  },
  beforeDestroy() {
    restoreViewport();
  }
};
